import { RANGE_OPTIONS, type RangeKind } from "../lib/format";

export function RangePicker({ kind, onChange }: { kind: RangeKind; onChange: (kind: RangeKind) => void }) {
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5">
      {RANGE_OPTIONS.map((option) => (
        <button
          key={option.kind}
          type="button"
          onClick={() => onChange(option.kind)}
          className={
            kind === option.kind
              ? "rounded-md bg-slate-900 px-2.5 py-1 text-xs font-medium text-white"
              : "rounded-md px-2.5 py-1 text-xs font-medium text-slate-500 transition hover:text-slate-800"
          }
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
